module.exports = __webpack_public_path__ + "img/pgd_a_11011.438ad8bc.png";